export const namespace = 'IPPINPLUE'
